import { Form, Input, message, AutoComplete } from 'antd';
import React, { useState, useMemo, useContext } from 'react';
import { sendCode, doRelativeLogin } from '@api/login';
// import { getCurrentUserInfo } from "@api/user";
import { getDecodeUrl, isHadParam } from '@util/utils';
import './login_interceptor.less';
import SliderModal from './react-slider-vertify/slider'
import './login_interceptor.less'
import useLogin from '../useLogin';
import { getkey } from '../../../util/utils';
import Captcha from '@pages/aliyun_captcha/App';
import uuid from 'react-uuid'
import { debounce } from 'lodash';
import loginContext from "@components/login_context";
import { useTranslation } from "react-i18next";
import {
  consumeLoginModalWechatReturnContext,
  getLoginModalWechatReturnContext,
} from '@components/login_modal/wechatReturn';
import {
  clearPrivateMemberInvitationForTeam,
  getPrivateMemberInvitationForTeam,
} from '@components/login_modal/privateMemberInvitation';
import H5FormError from "./h5_form_error";
import FormFieldError from "@components/form_field_error";

let interval = null;
export default function Bindmobilenumber({ appCode = null, callBack = null, unicode_url = null, isShop = null, shopPlatFun }) {
  
  const {  isPhone } = useContext(loginContext);
  const { t } = useTranslation();
  const [bindPhoneForm] = Form.useForm();
  const [fieldErrors, setFieldErrors] = useState({});
  if (appCode == "") {
    appCode = getkey('appCode')
  }
  const [unicode, setUcode] = useState('');
  const [tipName, setTipName] = useState("发送验证码")
  const [disabled, setDisabled] = useState(false)
  // const [interval, set_interval] = useState(null)
  const [slider, setSlider] = useState(false)
  const [sliderVisible, setSliderVisible] = useState(false)
  const [sendNum, setSendNum] = useState(0)
  const [time, setTime] = useState(0)
  const [options, setOptions] = useState([]);

  const identityType_local = localStorage.getItem('identityType');
  const buttonKey = useMemo(()=>{
    return 'captcha-button-'+uuid()
  },[])
  const reg = /^1[3-9][0-9]\d{8}$/;
  const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const prefixReg = /^\+86[- ]*/;
  const { identityType, getUrlByHadParam, noParamUrl, loginApi, handleSearch } = useLogin(unicode_url);
  const updateFieldErrors = (fields = []) => {
    const errors = {};
    fields.forEach((field) => {
      const fieldName = Array.isArray(field.name)
        ? field.name.join(".")
        : field.name;
      if (fieldName) {
        errors[fieldName] = field.errors || [];
      }
    });
    setFieldErrors(errors);
  };
  const handleFinishFailed = ({ errorFields = [] } = {}) => {
    updateFieldErrors(errorFields);
  };
  const renderFieldError = (fieldName) => {
    const error = fieldErrors[fieldName]?.[0];
    // PC 端与 H5 端展示同样的异常提醒，PC 样式参考 pc-login-modal 的字段报错。
    if (!isPhone) return <FormFieldError error={error} />;
    return <H5FormError error={error} />;
  };
  const sendSmsCode = (res) => {
    const phone = bindPhoneForm.getFieldValue('phone');
    if (!phone || disabled) {
      return
    }
    if (!sendNum) {
      setTime(new Date().getTime());
    }
    setSendNum(sendNum + 1);
    let nowTime = new Date().getTime();
    if (sendNum > 4 && (((nowTime - time) / 1000) < 60000)) {
      setSliderVisible(true);
      setSlider(true);
    }
    sendCode({
      phone,
      phoneCodeId: res.phoneCodeId
    }).then(res => {
      if (res.success) {
        let num = 60;
        setDisabled(true);
        interval = setInterval(() => {
          if (num >= 1) {
            num -= 1;
          }
          num > 0 ? setTipName(num) : setTipName("发送验证码");
          if (num <= 0) {
            setDisabled(false);
            clearInterval(interval);
          }
        }, 1000)
        setUcode(res.result.unicode)
      } else {
        message.error(t(res.errorInfo || "获取验证码失败,请重新获取"))
      }

    })
  }
  const forgetLoginFn = (e) => {
    e.stopPropagation();
    if (slider) {
      message.warn(t("请先完成拼图"));
      return
    }
    bindPhoneForm.submit();
  }

  const forgetLogin = debounce(forgetLoginFn, 300)
  // 获取商城token
  const getShopToken = (token, url) => {
    doRelativeLogin({ token, source: 'MATERIAL', platform: 'MATERIAL_MALL_H5' }).then(res => {
      if (res.token) {
        sessionStorage.setItem('shop_callback', '');
        const new_url = getDecodeUrl(url);
        const str = isHadParam(new_url);
        location.replace(new_url + str + 'token=' + token);
      }
    })
  }
  // const loginSucCallback = (res) => {
  //   if(sessionStorage.getItem('shop_callback')){
  //     getShopToken(res.token,sessionStorage.getItem('shop_callback'));
  //     return;
  //   }
  //   if (
  //     sessionStorage.getItem("isFirst") === "1" ||
  //     res.result.firstRegistration
  //   ) {
  //     window.location.href = `${window.location.origin}/team_create.html`;
  //     return;
  //   }
  //   if (res.result?.lastUrl) {
  //     // 将上次记录域名换成'/'
  //     let lastUrl = getLastOrigin(res.result?.lastUrl);
  //     if(lastUrl.indexOf('token')){
  //       lastUrl = lastUrl.replace('token','test');
  //     }
  //     localStorage.setItem('lastUrl',lastUrl);
  //     // 上传最后记录是供应商入驻页
  //     if (lastUrl.indexOf("/supplier_settle.html") >= 0) {
  //       getCurrentUserInfo().then((result) => {
  //         const user = result || {};
  //         // 判断是否入驻成功
  //         if (
  //           !user?.client ||
  //           user?.client?.checkStatus * 1 === 2 ||
  //           user?.client?.checkStatus * 1 === 0
  //         ) {
  //           window.location.href = lastUrl;
  //         } else if (user?.client?.isForbidden) {
  //           window.location.href = `${window.location.origin}/supply_stop.html`;
  //         } else {
  //           window.location.href = `${window.location.origin}/supplier.html/#/product_collection`;
  //         }
  //       });
  //       return;
  //     }
  //     window.location.href = lastUrl;
  //   } else {
  //     localStorage.setItem('lastUrl','');
  //     window.location.href = `${window.location.origin}/`;
  //   }
  // };
  // const loginSucFun = () =>{
  //   const share_product = getkey('share_product')||localStorage.getItem('share_product');
  //   const entrust =  getkey('entrust')||localStorage.getItem('entrust');
  //   const clientId =  getkey('clientId')||localStorage.getItem('clientId');
  //   const unicode =  getkey('unicode')||localStorage.getItem('unicode');
  //   const inviteCode =  getkey('inviteCode')||localStorage.getItem('inviteCode');
  //   const share_main = getkey('share_main')||localStorage.getItem('share_main');
  //   const isAddTeam = unicode_url&&unicode_url!='null'?unicode_url:unicode;
  //   let str =''
  //   if(share_product){
  //     localStorage.setItem('share_product','');
  //     str=`/product_detail_share.html?id=${share_product}`;
  //   }
  //   if(entrust){
  //     localStorage.setItem('entrust','');
  //       localStorage.setItem('clientId','');
  //     if(clientId === entrust){
  //       str=`/create_product.html?clientType=3&clientId=${entrust}&operation=CREATE&entrust=${entrust}`;
  //     }else{
  //       str = `/entrust_product.html?key=${entrust}`
  //     }
  //   }
  //   if(isAddTeam){
  //     localStorage.setItem('unicode','');
  //     str=`/team_join_link.html?unicode=${isAddTeam}`;
  //   }
  //   if((identityType_local||identityType)&&!entrust){
  //     if(identityType_local) localStorage.setItem('identityType','');
  //     str=`/material_square.html`;
  //   }
  //   if(inviteCode){
  //     localStorage.setItem('inviteCode','');
  //     str= `/invite_settle.html?inviteCode=${inviteCode}`;
  //   }
  //   if(share_main){
  //     localStorage.setItem('share_main','');
  //     str = `/share_page.html?key=${share_main}&isProduct=1`;
  //   }
  //   return str;
  // }
  const phone = Form.useWatch('phone',bindPhoneForm)

  const captchaOpen = useMemo(()=>{
    return  phone && (reg.test(phone) || emailReg.test(phone)) && !disabled
  },[phone,disabled])

  return (
    <div className={isPhone ? "boxMask phoneLoginMask" : "boxMask"}>
      <div className={isPhone ? "boxContent phoneLoginContent" : "boxContent"}>
        <div className="text_title">
          <span>{t("绑定手机号/邮箱")}</span>
          {/* <div className="image-wrapper_4" onClick={(e) => {
            e.stopPropagation();
            setDisabled(false);
            clearInterval(interval);
            setTipName("发送验证码");
            setBindPhoneVisible(false)
          }}>
            <img
              className="thumbnail_2"
              referrerPolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/pshr6c9dhlxm56xubgb1swhjj7c6idxbd7iac80a6e6-3d59-4dbf-a6fa-c87ab8e8531e"
            />
          </div> */}
        </div>
        <Form
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 20 }}
          form={bindPhoneForm}
          validateTrigger="onBlur"
          onFieldsChange={(_changedFields, allFields) =>
            updateFieldErrors(allFields)
          }
          onFinishFailed={handleFinishFailed}
          onFinish={data => {
            const loginModalWechatReturn = getLoginModalWechatReturnContext();
            const invitation = getPrivateMemberInvitationForTeam(
              loginModalWechatReturn?.teamId
            );
            const privateMemberLoginParams = loginModalWechatReturn?.shouldJoin
              ? {
                  teamId:
                    invitation?.targetTeamId || loginModalWechatReturn.teamId,
                  ...(invitation?.source || loginModalWechatReturn.source
                    ? {
                        source:
                          invitation?.source || loginModalWechatReturn.source,
                      }
                    : {}),
                  ...(invitation?.inviterId || loginModalWechatReturn.inviterId
                    ? {
                        inviterId:
                          invitation?.inviterId ||
                          loginModalWechatReturn.inviterId,
                      }
                    : {}),
                }
              : {};
            let params = {
              ...data,
              unicode,
              loginType: "SMS",
              redirectUrl: "/",
              bindPhone:true,
              ...privateMemberLoginParams,
            }
            if (appCode) {
              params = { ...params, appCode }
            }
            if (identityType || identityType_local) params = { ...params, identityType: 2 }
            loginApi(params, res => {
              if (res.success) {
                clearPrivateMemberInvitationForTeam(
                  privateMemberLoginParams.teamId
                );
                if (isShop) {
                  shopPlatFun(res.token);
                  return
                }
                setDisabled(false);
                setTipName("发送验证码");
                clearInterval(interval);
                message.success(t("绑定成功！"));
                bindPhoneForm.resetFields();
                const consumedLoginModalReturn = consumeLoginModalWechatReturnContext();
                const loginModalReturnUrl =
                  consumedLoginModalReturn?.returnUrl ||
                  loginModalWechatReturn?.returnUrl;
                if (loginModalReturnUrl) {
                  window.location.replace(loginModalReturnUrl);
                  return;
                }
                if (callBack) {
                  callBack();
                  return;
                }
                const openUrl = getkey('openUrl')
                if (openUrl) {
                  localStorage.setItem('entrust', "")
                }
                const url = getUrlByHadParam();

                if (url && url != "") {
                  window.location.replace(window.location.origin + url);
                  return
                }
                if (openUrl) {
                  window.location.replace(decodeURIComponent(openUrl))
                  return
                }
                if (!appCode || !callBack) {
                  if (sessionStorage.getItem('shop_callback')) {
                    getShopToken(res.token, sessionStorage.getItem('shop_callback'));
                    return;
                  }
                  if (
                    (sessionStorage.getItem("isFirst") === "1" ||
                    res.result.firstRegistration)&&!res.result?.lastUrl
                  ) {
                    window.location.href = `${window.location.origin}/team_set_password.html`;
                    return;
                  }
                  noParamUrl(res);
                }
              } else {
                message.error(t(res.errorInfo))
              }
            }, isShop)
          }}
        >
          <Form.Item
            name="phone"
            help={renderFieldError("phone")}
            wrapperCol={{ offset: 2, span: 20 }}
            getValueFromEvent={(value) => {
              if (prefixReg.test(value)) {
                return value.replace(prefixReg, '');
              }
              return value;
            }}
            rules={[
              {
                required: true,
                message: t("请输入正确的手机号或邮箱账号!"),
              },
              () => ({
                validator(_, value) {
                  let new_value = value;
                  if (prefixReg.test(value)) {
                    new_value = value.replace(prefixReg, '')
                  }
                  if (reg.test(new_value) || emailReg.test(new_value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("请输入正确的手机号或邮箱账号!")));
                },
              }),
            ]}
          >
            {/* <Input placeholder='手机号' /> */}
            <AutoComplete
              options={options}
              onChange={(val) => handleSearch(val, setOptions)}
              style={{ width: '100%' }}>
              <Input
                placeholder={t("输入手机号或邮箱")}
              />
            </AutoComplete>
          </Form.Item>
          <Form.Item
            name="code"
            help={renderFieldError("code")}
            wrapperCol={{ offset: 2, span: 20 }}
            rules={[{ required: true, message: t("验证码不能为空!") }]}
          >
            <Input placeholder={t("验证码")} maxLength={6} suffix={<span
            onClick={(e)=>{e.stopPropagation()}}
            id={captchaOpen?buttonKey:""}
            >{t(tipName)}</span>} />
          </Form.Item>
        </Form>
        <SliderModal setSlider={setSlider} sliderVisible={sliderVisible}></SliderModal>
        <div className="text-wrapper_4" onClick={forgetLogin}>
          <span >{t("确定")}</span>
        </div>
      </div>
      {captchaOpen && <Captcha button={`#${buttonKey}`} phone={phone}  mode={'popup'} callBack={(res)=>{
        if(res){ 
          sendSmsCode(res)
        }
      }} />}
    </div>)
}
